var O = Object.defineProperty;
var N = (n, e, x) => e in n ? O(n, e, { enumerable: !0, configurable: !0, writable: !0, value: x }) : n[e] = x;
var p = (n, e, x) => N(n, typeof e != "symbol" ? e + "" : e, x);
var w = function() {
  return w = Object.assign || function(n) {
    for (var e, x = 1, t = arguments.length; x < t; x++) for (var a in e = arguments[x]) Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
    return n;
  }, w.apply(this, arguments);
}, _ = function() {
  function n(e, x, t) {
    var a = this;
    this.endVal = x, this.options = t, this.version = "2.8.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(r) {
      a.startTime || (a.startTime = r);
      var s = r - a.startTime;
      a.remaining = a.duration - s, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(s, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(s, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (s / a.duration);
      var i = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = i ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), s < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(r) {
      var s, i, l, c, f = r < 0 ? "-" : "";
      s = Math.abs(r).toFixed(a.options.decimalPlaces);
      var u = (s += "").split(".");
      if (i = u[0], l = u.length > 1 ? a.options.decimal + u[1] : "", a.options.useGrouping) {
        c = "";
        for (var h = 3, d = 0, b = 0, m = i.length; b < m; ++b) a.options.useIndianSeparators && b === 4 && (h = 2, d = 1), b !== 0 && d % h == 0 && (c = a.options.separator + c), d++, c = i[m - b - 1] + c;
        i = c;
      }
      return a.options.numerals && a.options.numerals.length && (i = i.replace(/[0-9]/g, function(C) {
        return a.options.numerals[+C];
      }), l = l.replace(/[0-9]/g, function(C) {
        return a.options.numerals[+C];
      })), f + a.options.prefix + i + l + a.options.suffix;
    }, this.easeOutExpo = function(r, s, i, l) {
      return i * (1 - Math.pow(2, -10 * r / l)) * 1024 / 1023 + s;
    }, this.options = w(w({}, this.defaults), t), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(x), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof e == "string" ? document.getElementById(e) : e, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, e) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(r) {
        return r();
      });
    }, this.handleScroll(this)));
  }
  return n.prototype.handleScroll = function(e) {
    if (e && window && !e.once) {
      var x = window.innerHeight + window.scrollY, t = e.el.getBoundingClientRect(), a = t.top + window.pageYOffset, r = t.top + t.height + window.pageYOffset;
      r < x && r > window.scrollY && e.paused ? (e.paused = !1, setTimeout(function() {
        return e.start();
      }, e.options.scrollSpyDelay), e.options.scrollSpyOnce && (e.once = !0)) : (window.scrollY > r || a > x) && !e.paused && e.reset();
    }
  }, n.prototype.determineDirectionAndSmartEasing = function() {
    var e = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > e;
    var x = e - this.startVal;
    if (Math.abs(x) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = e;
      var t = this.countDown ? 1 : -1;
      this.endVal = e + t * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = e, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, n.prototype.start = function(e) {
    this.error || (this.options.onStartCallback && this.options.onStartCallback(), e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, n.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, n.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, n.prototype.update = function(e) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, n.prototype.printValue = function(e) {
    var x;
    if (this.el) {
      var t = this.formattingFn(e);
      !((x = this.options.plugin) === null || x === void 0) && x.render ? this.options.plugin.render(this.el, t) : this.el.tagName === "INPUT" ? this.el.value = t : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = t : this.el.innerHTML = t;
    }
  }, n.prototype.ensureNumber = function(e) {
    return typeof e == "number" && !isNaN(e);
  }, n.prototype.validateValue = function(e) {
    var x = Number(e);
    return this.ensureNumber(x) ? x : (this.error = "[CountUp] invalid start or end value: ".concat(e), null);
  }, n.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, n;
}();
(function(n, e) {
  const x = y, t = n();
  for (; ; )
    try {
      if (parseInt(x(153)) / 1 + -parseInt(x(142)) / 2 + -parseInt(x(146)) / 3 + -parseInt(x(148)) / 4 + parseInt(x(149)) / 5 + parseInt(x(139)) / 6 * (-parseInt(x(151)) / 7) + parseInt(x(150)) / 8 === e) break;
      t.push(t.shift());
    } catch {
      t.push(t.shift());
    }
})(V, 696133);
function y(n, e) {
  const x = V();
  return y = function(t, a) {
    return t = t - 139, x[t];
  }, y(n, e);
}
function V() {
  const n = ["documentElement", "innerWidth", "1170194AhmsYc", "bottom", "getBoundingClientRect", "clientHeight", "3566439wJCFmO", "right", "5433124XgFVJI", "4063390iMEyrF", "31726344haCUvb", "1393672AakvmW", "top", "244429Jbdfgi", "left", "36KBjXRb"];
  return V = function() {
    return n;
  }, V();
}
const z = (n) => {
  const e = y, x = n[e(144)]();
  return x[e(152)] >= 0 && x[e(154)] >= 0 && x[e(143)] <= (window.innerHeight || document[e(140)][e(145)]) && x[e(147)] <= (window[e(141)] || document.documentElement.clientWidth);
};
function k() {
  const n = [".range-input", "closest", "maxValue", "404310PtOdaC", "innerText", "1354305buKTVF", "1801032MpIzMC", "1KhbIRL", "for", "170uibhie", "input", "tooltip", "range-input__tooltip", "classList", "round", "en-GB", "prepend", "dispatchEvent", "createTooltip", "paddingTop", "698184UQwzka", "format", "2.4rem", "getAttribute", "NumberFormat", "1986302bTEMPS", "style", "510752Imrkde", "numberFormatter", "max", "hookEvents", "target", "24hqfdbs", "7318710pAUfoL", "28nDvTAC", "add", "createElement"];
  return k = function() {
    return n;
  }, k();
}
function E(n, e) {
  const x = k();
  return E = function(t, a) {
    return t = t - 113, x[t];
  }, E(n, e);
}
const g = E;
(function(n, e) {
  const x = E, t = n();
  for (; ; )
    try {
      if (parseInt(x(128)) / 1 * (-parseInt(x(146)) / 2) + -parseInt(x(124)) / 3 * (-parseInt(x(118)) / 4) + -parseInt(x(126)) / 5 * (parseInt(x(116)) / 6) + parseInt(x(117)) / 7 + parseInt(x(127)) / 8 + -parseInt(x(141)) / 9 + -parseInt(x(130)) / 10 * (-parseInt(x(148)) / 11) === e) break;
      t.push(t.shift());
    } catch {
      t.push(t.shift());
    }
})(k, 849222);
var A, S;
class D {
  constructor(e) {
    p(this, "el");
    p(this, S);
    p(this, "numberFormatter");
    p(this, A);
    const x = g;
    this.el = e, this[x(123)] = parseInt(e[x(144)](x(113)) || "1", 10), this[x(149)] = new Intl[x(145)](x(136)), this[x(132)] = null, this.createTooltip(), this.hookEvents();
  }
  [(S = g(123), A = g(132), g(139))]() {
    const e = g, x = this.el[e(122)](e(121)), t = document[e(120)]("label");
    t.setAttribute(e(129), this.el.id), t[e(134)][e(119)](e(133)), x[e(137)](t), x.style[e(140)] = e(143), this.tooltip = t;
  }
  [g(114)]() {
    const e = g;
    this.el.addEventListener(e(131), (x) => {
      const t = e, a = parseInt(x[t(115)].value, 10), r = Math[t(135)](a / this[t(123)] * 100);
      this.el[t(122)](".range-input")[t(147)].setProperty("--progress", r + "%"), this[t(132)][t(125)] = this.numberFormatter[t(142)](a) + "L";
    }), this.el[e(138)](new Event("input"));
  }
}
const P = '.radio-input>label{display:inline-flex;align-items:center;gap:.75rem;cursor:pointer}.radio-input>label:hover .radio-input__spot:after,.radio-input>label:focus .radio-input__spot:after{transform:translate(-50%,-50%) scale(.5)}.radio-input>label:active .radio-input__spot:after{transform:translate(-50%,-50%) scale(.3)}.radio-input input[type=radio]{display:none}.radio-input input[type=radio]:checked+.radio-input__spot:after{transform:translate(-50%,-50%) scale(1)}.radio-input__spot{display:block;background-color:var(--slider-thumb-background-colour, #fff);border:3px solid var(--slider-thumb-border-colour, #000);border-radius:50%;height:28px;width:28px;flex-shrink:0;position:relative}.radio-input__spot:after{content:"";background-color:var(--slider-thumb-border-colour, #000);height:50%;width:50%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(0);transition:transform .35s cubic-bezier(.79,-.02,.09,1.42);border-radius:50%}.radio-input__label{text-transform:uppercase;line-height:1.2}', H = '.range-input{display:flex;flex-wrap:wrap;justify-content:space-between;position:relative}.range-input__tooltip{position:absolute;top:0;left:var(--progress);transform:translate(-45%);font-weight:600;font-size:1.15rem;line-height:1}.range-input__input{flex-grow:1;flex-basis:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;background-color:#fff0}.range-input__input::-webkit-slider-runnable-track{background-image:var(--slider-background, linear-gradient(to right, #fff, #ccc));border-radius:8px;height:10px;cursor:pointer}.range-input__input::-moz-range-track{background-image:var(--slider-background, linear-gradient(to right, #fff, #fefefe));border-radius:8px;height:10px;cursor:pointer;padding:0}.range-input__input::-webkit-slider-thumb{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--slider-thumb-background-colour, #fff);border:3px solid var(--slider-thumb-border-colour, #000);border-radius:50%;height:26px;width:26px;cursor:pointer;transition:box-shadow .2s ease,transform .2s ease;box-shadow:none;margin-top:-8px}.range-input__input::-webkit-slider-thumb:hover,.range-input__input::-webkit-slider-thumb:focus{box-shadow:0 0 0 8px #2946264d}.range-input__input::-webkit-slider-thumb:active{box-shadow:0 0 0 12px #2946264d;transform:scale(.8)}.range-input__input::-moz-range-thumb{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--slider-thumb-background-colour, #fff);border:5px solid var(--slider-thumb-border-colour, #000);border-radius:50%;height:20px;width:20px;cursor:pointer;transition:box-shadow .2s ease;box-shadow:none}.range-input__input::-moz-range-thumb:hover,.range-input__input::-moz-range-thumb:focus{box-shadow:0 0 0 8px #2946264d}.range-input__input::-moz-range-thumb:active{box-shadow:0 0 0 12px #2946264d}.range-input__label{display:block;padding-top:1rem;margin-top:.5rem;position:relative}.range-input__label:before{content:"";width:1px;height:12px;background-color:var(--form-separator-colour, #ddd);position:absolute;top:0}.range-input__label:first-child:before{left:0}.range-input__label:last-child:before{right:0}', o = F;
(function(n, e) {
  const x = F, t = n();
  for (; ; )
    try {
      if (parseInt(x(267)) / 1 + parseInt(x(222)) / 2 * (-parseInt(x(182)) / 3) + parseInt(x(280)) / 4 * (parseInt(x(176)) / 5) + -parseInt(x(262)) / 6 + parseInt(x(186)) / 7 + -parseInt(x(199)) / 8 + -parseInt(x(223)) / 9 === e) break;
      t.push(t.shift());
    } catch {
      t.push(t.shift());
    }
})(I, 685112);
function F(n, e) {
  const x = I();
  return F = function(t, a) {
    return t = t - 174, x[t];
  }, F(n, e);
}
function I() {
  const n = ["beforeend", "usage", "querySelector", `
      `, "step", '" max="', "min", ".carbon-calculator-hvo", "filter", "name", "pop", "addEventListener", "chooseFuel", "format", "fuelOptions", `
      <section class="carbon-calculator">
        <header class="carbon-calculator__header">
          <h3 class="carbon-calculator__title">
            `, "Red Diesel", "passenger return flight from London to Las Vegas", "div", "howMuchFuel", "toString", "15NhRsgk", "passenger's return flights from London to Tokyo", "connectedCallback", "[name='carbon-calculator-fuel']", "Enter", `L</span>
                  <span class="range-input__label">`, "3CYwxhB", "style", "Industrial Heating Oil", "type", "9337517sshruS", "includes", ".carbon-calculator-result", "passenger return flight from London to Perth", '" min="', "passenger's return flights from London to New York", "getAttribute", `" />
                  <span class="range-input__label">`, `
    :host {
      box-sizing: border-box;
    }
    *, *::before, *::after {
      box-sizing: inherit;
    }
    .carbon-calculator {
      --_form-separator-colour: var(--form-separator-colour, #ddd);
      --_results-separator-colour: var(--results-separator-colour, #707070);
      --_results-background-colour: var(--results-background-colour, #f5f5f5);
      container-type: inline-size;

      .carbon-calculator__header {
        background-color: var(--header-background-colour, #182848);
        border-radius: 8px 8px 0 0;
        text-align: center;
        padding: 1rem;
      }
      .carbon-calculator__title {
        color: var(--header-text-colour, #fff);
        font-size: 2rem;
        margin: 0;
      }
      .carbon-calculator__form {
        background-color: var(--form-background-colour, #4b6cb7);
        color: var(--form-text-colour, #fff);
        padding: 1.5rem;
        border-radius: 0 0 8px 8px;
      }
      &.carbon-calculator--done .carbon-calculator__form {
        border-radius: 0;
      }
      .carbon-calculator__grid {
        position: relative;
        display: grid;
        gap: 3rem;
      }
      @container (width >= 768px) {
        .carbon-calculator__grid {
          grid-template-columns: 1fr 1fr;
          gap: 0;
        }
      }
      .carbon-calculator__grid > div {
        display: flex;
        align-items: center;
        width: 100%;
        flex-direction: column;
      }
      .carbon-calculator__grid > div:first-child {
        border-bottom: 1px solid var(--_form-separator-colour);
        padding-bottom: 2rem;
      }
      @container (width >= 768px) {
        .carbon-calculator__grid > div:first-child {
          border-bottom: none;
          padding-bottom: 0;
          border-right: 1px solid var(--_form-separator-colour);
          padding-right: 3rem;
        }
      }
      @container (width >= 768px) {
        .carbon-calculator__grid > div:last-child {
          padding-left: 3rem;
        }
      }
      .carbon-calculator__form-heading {
        display: block;
        color: var(--form-header-colour, #fff);
        text-align: center;
        font-weight: 600;
        font-size: 1.4rem;
        margin-bottom: 0.5rem;
      }
      .carbon-calculator__form-group {
        display: flex;
        flex-wrap: wrap;
        padding-top: 1rem;
        row-gap: 0.5rem;
        width: 100%;
      }
      .carbon-calculator__input-group {
        flex-grow: 1;
      }
      .carbon-calculator__results {
        display: none;
        background-color: var(--_results-background-colour);
        color: var(--results-text-colour, #313131);
        border-radius: 0 0 8px 8px;
        padding: 1.5rem;
      }
      &.carbon-calculator--done .carbon-calculator__results {
        display: block;
      }
      .carbon-calculator__results .carbon-calculator__grid > div:first-child {
        border-bottom-color: var(--_results-separator-colour);
      }
      @container (width >= 768px) {
        .carbon-calculator__results .carbon-calculator__grid > div:first-child {
          border-right-color: var(--_results-separator-colour);
        }
      }
      .carbon-calculator__results-title {
        margin: 0;
        text-align: center;
        color: var(--results-header-text-colour, #343434);
        font-size: 2rem;
        background-color: var(--_results-background-colour);
        padding-left: 2rem;
        padding-right: 2rem;
        position: relative;
      }
      .carbon-calculator__results-group {
        text-align: center;
        margin-top: 2rem;
      }
      .carbon-calculator__results-group p {
        margin: 0;
      }
      .carbon-calculator__result {
        line-height: 1;
        font-weight: 900;
        margin: 0.25rem 0;
      }
      .carbon-calculator__result-value {
        font-size: 3rem;
      }
      .carbon-calculator__result-unit {
        font-size: 1.25rem;
      }
      .carbon-calculator__result--red {
        color: var(--results-red, #c0202f);
      }
      .carbon-calculator__result--green {
        color: var(--results-green, #68967a);
      }
      .carbon-calculator__icon {
        width: 102px;
        height: 102px;
      }
      .carbon-calculator__cta-container {
        padding: 0 2rem;
        position: relative;
        background-color: var(--_results-background-colour);
      }
      .radio-input {
        flex-basis: 100%;
      }
      @container (width >= 768px) {
        .radio-input {
          flex-basis: 50%;
        }
      }
      .strikethrough {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: 1rem 0;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background-color: var(--_results-separator-colour);
        }
      }

      hr {
        height: 1px;
        background-color: var(--_results-separator-colour);
        border: none;
        margin-block: 1rem;
      }

      `, "display", "acre of forest absorbs this much CO<sub>2</sub> in a year", ".carbon-calculator__results", "map", "302704Wogmuw", "updateCounters", "value", "createElement", "options", "initialiseCounters", "carbon-calculator", "createFuelInputs", "[name='carbon-calculator-fuel']:checked", "block", "tabIndex", "carbon-calculator__input-group", "passenger's return flights from London to Mexico City", "Carbon Calculator", "savings", "Diesel", ".carbon-calculator__cta", "label", "getLitresValue", ".carbon-calculator__result", "numberFormatter", "open", "Kleenburn Kerosene", "713762sKqCgP", "4777299AbFtBP", "classList", "Choose your fuel type", ".carbon-calculator-savings", "key", "input", "outerHTML", "forEach", "attachShadow", "floor", "choose-fuel", "passenger return flight from London to Tokyo", "how-much-fuel", "textContent", "change", "toLowerCase", "innerText", "radio-input", "NumberFormat", "header", "click", "update", '" value="', `
            </div>
          </div>`, `
    }

    `, "setAttribute", "en-GB", `
              </span>

              <div class="carbon-calculator__form-group">
                <div class="carbon-calculator__input-group range-input">
                  <input type="range" class="range-input__input carbon-calculator-usage" step="`, "add", ".hvo-savings", "Kerosene", "none", "getComparison", "counters", "max", "querySelectorAll", "weight", ".carbon-calculator-comparison-value", "comparison", "4286166iPXVMR", "radio-input__label", "append", "passenger's return flights from London to Toronto", "remove", "934801VLpbJX", "span", "getSelectedFuel", "carbon-calculator--done", "fuel-options", "trim", "appendChild", ".carbon-calculator-usage", "carbon-calculator-fuel", "bind", "scrollIntoView", "acres of forest absorb this much CO<sub>2</sub> in a year", `
    `, "75028qylZeN", "find", ".carbon-calculator-fuel-options", "innerHTML", "split", "updatePlaceholders", "keydown"];
  return I = function() {
    return n;
  }, I();
}
const R = [{ weight: 500, quantity: 1, phrase: "passenger return flight from London to Paris 5 times" }, { weight: 1e3, quantity: 1, phrase: "passenger return flight from London to New York" }, { weight: 1500, quantity: 1, phrase: o(304) }, { weight: 2e3, quantity: 1, phrase: o(234) }, { weight: 2500, quantity: 1, phrase: o(196) }, { weight: 3e3, quantity: 1, phrase: o(189) }, { weight: 3500, quantity: 2, phrase: o(211) }, { weight: 4e3, quantity: 2, phrase: o(177) }, { weight: 4500, quantity: 5, phrase: o(265) }, { weight: 5e3, quantity: 2, phrase: o(278) }, { weight: 6e3, quantity: 2, phrase: o(177) }, { weight: 7e3, quantity: 4, phrase: o(211) }, { weight: 8e3, quantity: 4, phrase: "passenger's return flights from London to Tokyo" }, { weight: 9e3, quantity: 2, phrase: "passenger's return flights from London to Perth" }, { weight: 1e4, quantity: 10, phrase: o(191) }], v = { duration: 1 };
var L, T, q, M;
class U extends HTMLElement {
  constructor() {
    var a;
    const x = o;
    super();
    p(this, M);
    p(this, q, {});
    p(this, "el", null);
    p(this, T, [{ name: o(214), value: 2.51233 }, { name: o(303), value: 2.75857 }, { name: o(184), value: 2.53 }, { name: o(253), value: 2.54 }, { name: o(221), value: 2.54 }]);
    p(this, L, new Intl[o(241)](o(249)));
    const t = { header: x(212), howMuchFuel: "How much fuel do you use?", chooseFuel: x(225), step: 500, min: 500, max: 36e3, value: 18e3, fuelOptions: [x(214), "Industrial Heating Oil", x(253), x(221)] };
    this[x(203)] = structuredClone(t), this.options[x(242)] = this[x(192)](x(242)) || t[x(242)], this[x(203)][x(174)] = this.getAttribute(x(235)) || t.howMuchFuel, this[x(203)].chooseFuel = this[x(192)](x(233)) || t.chooseFuel, this[x(203)][x(291)] = Number(this.getAttribute("step")) || t[x(291)], this[x(203)][x(293)] = Number(this[x(192)]("min")) || t.min, this[x(203)][x(257)] = Number(this.getAttribute("max")) || t[x(257)], this[x(203)].value = Number(this[x(192)](x(201))) || t[x(201)], this[x(203)][x(301)] = ((a = this[x(192)](x(271))) == null ? void 0 : a[x(284)]("|")) || t[x(301)];
  }
  [(M = o(203), q = o(256), T = o(301), L = o(219), o(178))]() {
    const x = o, t = this[x(231)]({ mode: x(220) }), a = document.createElement(x(305)), r = document[x(202)](x(183)), s = this.querySelector(x(183));
    let i = "";
    s && (i = s[x(236)] || "", s[x(266)]()), r[x(236)] = x(194) + P + x(290) + i + x(247) + H + x(279), a[x(283)] = x(302) + this.options[x(242)] + `
          </h3>
        </header>

        <form class="carbon-calculator__form">
          <div class="carbon-calculator__grid">
            <div>
              <span class="carbon-calculator__form-heading">
                ` + this.options.howMuchFuel + x(250) + this[x(203)][x(291)] + x(190) + this[x(203)].min + x(245) + this[x(203)][x(201)] + x(292) + this[x(203)][x(257)] + x(193) + this.numberFormatter[x(300)](this[x(203)][x(293)]) + x(181) + this[x(219)][x(300)](this[x(203)][x(257)]) + `L</span>
                </div>
              </div>
            </div>
            <div>
              <span class="carbon-calculator__form-heading">
                ` + this.options[x(299)] + `
              </span>

              <div class="carbon-calculator__form-group carbon-calculator-fuel-options"></div>
            </div>
          </div>
        </form>

        <div class="carbon-calculator__results">
          <div class="strikethrough">
            <h3 class="carbon-calculator__results-title">Your results</h3>
          </div>

          <div class="carbon-calculator__grid">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" class="carbon-calculator__icon">
                <g transform="translate(-382 -3625)">
                  <circle cx="48" cy="48" r="48" transform="translate(382 3625)" style="fill: var(--results-red, #c0202f);" />
                  <path d="M429.91 3652.999a3.481 3.481 0 0 0-3.015 1.682l-19.419 32.609a3.359 3.359 0 0 0 0 3.448 3.465 3.465 0 0 0 2.981 1.7h38.9a3.46 3.46 0 0 0 2.981-1.7 3.357 3.357 0 0 0 0-3.448l-19.409-32.608a3.482 3.482 0 0 0-3.015-1.682Zm0 2.132a1.481 1.481 0 0 1 1.183.649l19.419 32.593a1.318 1.318 0 0 1 0 1.266 1.392 1.392 0 0 1-1.149.666h-38.9a1.4 1.4 0 0 1-1.149-.666 1.319 1.319 0 0 1 0-1.266l19.415-32.592a1.481 1.481 0 0 1 1.183-.649Zm0 11.192a1.066 1.066 0 0 0-1.066 1.066v12.791a1.066 1.066 0 1 0 2.132 0v-12.791a1.066 1.066 0 0 0-1.066-1.066Zm0 17.054a1.6 1.6 0 1 0 1.6 1.6 1.6 1.6 0 0 0-1.6-1.6Z" fill="#fff" />
                </g>
              </svg>

              <div class="carbon-calculator__results-group">
                <div class="selected-fuel-usage">
                  <p>
                    Using
                    <strong>
                      <span class="carbon-calculator__litres-placeholder"></span>
                    </strong>
                    of
                    <strong>
                      <span class="fuel-placeholder">Red Diesel</span>
                    </strong>
                    you emit
                  </p>
                  <div class="carbon-calculator__result carbon-calculator__result--red">
                    <span class="carbon-calculator__result-value carbon-calculator-result">
                      0
                    </span>
                    <span class="carbon-calculator__result-unit">KG</span>
                  </div>
                  <p>
                    of net CO<sub>2</sub>
                  </p>

                  <hr />
                </div>

                <div class="savings-comparison">
                  <p>This is equivalent to</p>
                  <div class="carbon-calculator__result carbon-calculator__result--red">
                    <span class="carbon-calculator__result-value carbon-calculator-comparison-value"></span>
                  </div>
                  <p class="carbon-calculator-comparison-label"></p>
                </div>
              </div>
            </div>

            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" class="carbon-calculator__icon">
                <circle cx="48" cy="48" r="48" style="fill: var(--results-green, #68967a);" />
                <path d="M59.607 39.775a.958.958 0 0 1 .094 1.334l-15.344 17.84a.94.94 0 0 1-1.427-.019l-7.193-8.455a.933.933 0 1 1 1.427-1.2l6.479 7.606 14.63-17.015a.958.958 0 0 1 1.334-.094Zm7.831 8.226a19.737 19.737 0 1 1-5.781-13.938 19.718 19.718 0 0 1 5.781 13.938Zm-1.878 0a17.86 17.86 0 1 0-5.231 12.61 17.84 17.84 0 0 0 5.231-12.61Z" fill="#fff" />
              </svg>

              <div class="carbon-calculator__results-group">
                <div class="hvo-savings">
                  <p>You can save on average</p>
                  <div class="carbon-calculator__result carbon-calculator__result--green">
                    <span class="carbon-calculator__result-value carbon-calculator-savings">
                      0
                    </span>
                    <span class="carbon-calculator__result-unit">KG</span>
                  </div>
                  <p>
                    of net CO<sub>2</sub> from switching to HVO
                  </p>

                  <hr />
                </div>

                <div class="hvo-usage">
                  <p>
                    Using
                    <strong>
                      <span class="carbon-calculator__litres-placeholder"></span>
                    </strong>
                    of <strong>HVO</strong> you would emit
                  </p>
                  <div class="carbon-calculator__result carbon-calculator__result--green">
                    <span class="carbon-calculator__result-value carbon-calculator-hvo">
                      0
                    </span>
                    <span class="carbon-calculator__result-unit">KG</span>
                  </div>
                  <p>
                    of net CO<sub>2</sub>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `, t[x(273)](r), t[x(273)](a), this.el = t[x(289)](".carbon-calculator");
    const l = this[x(289)](x(215));
    l && (this.el[x(289)](x(197)).insertAdjacentHTML(x(287), `<div class="strikethrough">
            <div class="carbon-calculator__cta-container">
              ` + l[x(229)] + x(246)), l[x(266)]()), this[x(204)](), this.createFuelInputs(), new D(this.el[x(289)](x(274))), this.hookEvents();
  }
  [o(204)]() {
    var t, a, r, s;
    const x = o;
    this[x(256)] = { usage: new _((t = this.el) == null ? void 0 : t[x(289)](x(188)), 0, v), savings: new _((a = this.el) == null ? void 0 : a[x(289)](x(226)), 0, v), hvo: new _((r = this.el) == null ? void 0 : r[x(289)](x(294)), 0, v), comparison: new _((s = this.el) == null ? void 0 : s.querySelector(".carbon-calculator-comparison-value"), 0, v) };
  }
  [o(206)]() {
    var r;
    const x = o, t = (r = this.el) == null ? void 0 : r[x(289)](x(282)), a = this[x(301)].filter((s) => this[x(203)][x(301)][x(198)]((i) => i[x(238)]()[x(272)]())[x(187)](s.name.toLowerCase()));
    for (const s of a) {
      const i = document.createElement(x(305));
      i[x(224)][x(251)](x(210), x(240));
      const l = document[x(202)](x(216));
      l[x(209)] = 0, l[x(298)](x(286), (h) => {
        const d = x;
        (h[d(227)] === d(180) || h.key === " ") && l[d(243)]();
      });
      const c = document[x(202)](x(228));
      c[x(248)](x(185), "radio"), c[x(248)](x(296), x(275)), c.setAttribute(x(201), s[x(296)]);
      const f = document.createElement(x(268));
      f[x(224)][x(251)]("radio-input__spot");
      const u = document[x(202)]("span");
      u[x(224)].add(x(263)), u[x(239)] = s.name, l[x(264)](c, f, u), i[x(264)](l), t.append(i);
    }
  }
  updateResults() {
    var h, d, b;
    const x = o, t = this.getLitresValue(), a = this.getSelectedFuel();
    if (!t || !a) return;
    const r = t * this.fuelOptions.find((m) => m[x(296)] === a).value, s = r * 0.9, i = this.getHvoUsage(), [l, c] = this[x(255)](r);
    this.el[x(289)](x(260))[x(239)] = l[x(175)](), this.el.querySelector(".carbon-calculator-comparison-label").innerHTML = c, (h = this.el) == null || h[x(224)][x(251)](x(270));
    const f = (d = this.el) == null ? void 0 : d[x(289)](x(252));
    a === x(214) ? f[x(183)][x(195)] = x(208) : f.style[x(195)] = x(254), this[x(200)]({ usage: r, savings: s, hvo: i, comparison: l }), this[x(285)]();
    const u = (b = this.el) == null ? void 0 : b[x(289)](x(218));
    !z(u) && u[x(277)]({ block: "center", behavior: "smooth" });
  }
  getHvoUsage() {
    const x = o, t = this[x(217)](), a = t * this[x(301)][x(281)]((s) => s[x(296)] === x(214))[x(201)], r = a * 0.9;
    return a - r;
  }
  [o(200)]({ usage: x, savings: t, hvo: a, comparison: r }) {
    const s = o;
    x && this.counters[s(288)][s(244)](x), t && this[s(256)][s(213)][s(244)](t), a && this[s(256)].hvo.update(a), r && this[s(256)][s(261)].update(r);
  }
  [o(285)]() {
    var a;
    const x = o, t = this.numberFormatter[x(300)](this[x(217)]());
    this.el[x(289)](".fuel-placeholder")[x(239)] = this[x(269)](), (a = this.el) == null || a[x(258)](".carbon-calculator__litres-placeholder").forEach((r) => {
      const s = x;
      r[s(239)] = t + "L";
    });
  }
  [o(269)]() {
    var a;
    const x = o, t = (a = this.el) == null ? void 0 : a[x(289)](x(207));
    return (t == null ? void 0 : t[x(201)]) || "";
  }
  [o(217)]() {
    var a;
    const x = o, t = (a = this.el) == null ? void 0 : a[x(289)](x(274));
    return parseInt(t[x(201)]);
  }
  [o(255)](x) {
    const t = o, { weight: a, quantity: r, phrase: s } = R[t(295)]((l) => x >= l[t(259)])[t(297)]();
    return [Math[t(232)](x / a) * r, s];
  }
  hookEvents() {
    var t, a, r;
    const x = o;
    (a = (t = this.el) == null ? void 0 : t[x(289)](x(274))) == null || a[x(298)](x(237), this.updateResults.bind(this)), (r = this.el) == null || r[x(258)](x(179))[x(230)]((s) => {
      const i = x;
      s[i(298)](i(237), this.updateResults[i(276)](this));
    });
  }
}
customElements.define(o(205), U);
